export const MODAL_TEST             = 'modal-test';
export const CONDITIONAL_MODAL_TEST = 'conditional-modal-test';

export const MODAL_TEST_CANCEL_BUTTON = 'modal-test-cancel-button';
export const MODAL_TEST_CONFIRM_BUTTON = 'modal-test-confirm-button';